import { Observable, interval } from 'rxjs';
import { switchMapTo, scan, takeWhile } from 'rxjs/operators';

import { ContextEnum, PlayerStatus, PlayerContext, Media } from '../entities';
import { getWaitListFromState, getFollowingTracks } from './playlist.query';
import { PlaylistRemoteAppState } from '../index';

const nakedStatus = {
  favorite: null,
  event: null,
  tempo: null,
  timeSlot: null,
};
export const buildPlayerStatusFrom = (payload: PlayerContext, state: PlaylistRemoteAppState): PlayerStatus => {
  const { context, event, id, favoriteRemainsTime, location = 'library' } = payload;
  let { media } = payload;
  let waitList: Media[] = [];
  const playerStatus: PlayerStatus = {
    playerContextType: context.toUpperCase(),
    [context]: { id }
  };

  switch (context) {
    case ContextEnum.favorite:
      ([media = {}, ...waitList] = getWaitListFromState(state, ContextEnum.event, event.id));
      playerStatus.favoriteRemainsTime = favoriteRemainsTime;
      playerStatus.event = event;
      break;
    case ContextEnum.timeSlot:
      const { activeDay } = state;
      const slot = state.schedule[activeDay].slots.find(s => s.id === id);
      const subState = slot.event ? ContextEnum.event : ContextEnum.tempo;
      ([media = {}, ...waitList] = getWaitListFromState(state, subState, slot[subState].id));
      break;
    case ContextEnum.history:
      const history = state.history.map(e => e.media);
      if (media) {
        waitList = history.filter(getFollowingTracks(media));
      } else {
        ([media = {}, ...waitList] = history);
      }
      playerStatus[context] = null;
      break;
    case ContextEnum.event:
    case ContextEnum.tempo:
      if (media && id) {
        waitList = getWaitListFromState(state, context, id).filter(getFollowingTracks(media));
      } else {
        ([media = {}, ...waitList] = getWaitListFromState(state, context, id));
      }
      break;
  }

  return {
    ...state.player,
    ...nakedStatus,
    ...playerStatus,
    media,
    waitList,
    state: 'PLAYING',
    isPlaying: true,
    location,
    context,
  };
};

export const startTimer = (
  favoriteRemainsTime: number,
  running$: Observable<boolean>,
  start: number = 0,
  millis: number = 150
): Observable<number> => interval(millis).pipe(
  switchMapTo(running$),
  scan((time: number, running: boolean) => running ? time + millis / 1000 : time, start),
  takeWhile(seconds => seconds <= favoriteRemainsTime),
);

const CONTEXT_MAP = {
  event: 'event',
  favorite: 'favorite',
  tempo: 'tempo',
  timeSlot: 'timeSlot',
  remote: 'timeSlot',
  place: 'timeSlot',
};
export const findPlayerContext = (status: PlayerStatus): string => {
  const [context] = Object.keys(status).filter(key => CONTEXT_MAP[key] && status[key] && status[key].id);
  return CONTEXT_MAP[context];
};
